import { render, staticRenderFns } from "./SelectStandardBs.vue?vue&type=template&id=721c71d8&"
import script from "./SelectStandardBs.vue?vue&type=script&lang=js&"
export * from "./SelectStandardBs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports